export default "__VITE_ASSET__Q6_$Jw_5__"